<template>
  <span>
    <Reason
      :compressed="compressed"
      :item-type="rowType"
      v-for="(reason,index) in matchReasons"
        :key="index"
        :reason="reason"
        :image-column="imageColumn"
        :story="story"
        :clickable="clickable"
        emit="reasonclicked"
        @reasonclicked="reasonClicked"
      ></Reason>
  </span>
</template>
<script>
import Reason from '@/components/Reason'
export default {
  name: 'Matches',
  props: {
    emit: String,
    matchReasons: Array,
    compressed: Boolean,
    rowType: String,
    imageColumn: Boolean,
    story: Array,
    clickable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    reasonClicked(pack) {
      if(this.emit) {
        this.$emit(this.emit, pack)
      }
    }
  },
  components: {
    Reason
  }
}
</script>
